<template>
  <div>
    <vs-card>
      <b-row align-v="center">
        <b-col cols="3">
          <b-form-input
            v-model="searchTerm"
            placeholder="Arama..."
            @keyup.enter="aramaFunc"
            type="text"
            class="d-inline-block"
          />
        </b-col>
        <b-col lg="7" sm="12" style="padding: 0; padding-right: 20px">
          <b-row align-h="start">
            <b-col cols="12" md="auto">
              <vs-button
                @click="aramaFunc"
                id="button-with-loading-yeni"
                class="vs-con-loading__container"
                line-origin="left"
                color="primary"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                >Listele</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto"
              ><vs-button
                v-on:click="yeniMusteriEkle()"
                line-origin="left"
                color="success"
                type="gradient"
                style="font-weight: bold; border-radius: 5px"
                >Yeni Müşteri</vs-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 10px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowSelection="rowSelection"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @rowClicked="onSelectionChanged"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import router from "../../router";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../store/store";
import state from "../../store/state";
import musterilerIlIlceCellRenderer from "./CellRenderers/musterilerIlIlceCellRenderer.vue";
import MusterilerDetayButon from "../components/crm-components/crm-components/MusterilerDetayButon.vue";

export default {
  data() {
    return {
      searchTerm: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      rowData: null,
      localeText: null,
      rowSelection: null,
    };
  },
  methods: {
    yeniMusteriEkle() {
      var itemName = "Crm";
      router.push({
        name: "MusterilerDetay",
        params: { item: itemName },
      });
      //INT_ADD_MUSTERI(string token, string musteriTur, string musteriAd, string musteriSoyad, string musteriTelefon, string musteriGsm, string musteriMail, string musteriAdres, string musteriIl, string musteriILce
      //   , string musteriUlke, string musteriVergiDairesi, string musteriVergiNo, string musteriAciklama, string userId)
    },
    onSelectionChanged(params) {
      //  this.$store.commit("account/TAHSILAT_DETAY", params.node.data);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    aramaFunc() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      if (this.searchTerm == "") {
        vs.notify({
          title: "Uyarı",
          text: "Arama değeri giriniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          aranan: this.searchTerm,
        };
        soap.createClient(url, function (err, client) {
          client.INT_MUSTERI_LIST(args, function (err, result) {
            if (result.INT_MUSTERI_LISTResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_MUSTERI_LISTResult);

              if (vm.veriler.response == "Ok") {
                var list = JSON.parse(vm.veriler.jsonData);
                console.log(list);
                vm.rowData = list;
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      }
    },
  },
  components: { AgGridVue, musterilerIlIlceCellRenderer, MusterilerDetayButon },
  created() {
    this.rowSelection = "single";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "MusterilerDetayButon",
      },
      {
        headerName: "Cari Durum",
        field: "CariDurum",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Adres",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "ADRES",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "E-Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Telefon",
        field: "PHONE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "İl/İlçe",
        field: "CITY, TOWN",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "musterilerIlIlceCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Bakiye",
        field: "BAKIYE",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
      },
    ];
  },
};
</script>